/**
 * Modelo de objeto de opções do Input de período;
 * @class InputPeriodoConfig
 * @namespace InputPeriodoConfig
 */
 export class InputPeriodoConfig {

    constructor(id, name, label, required = false, valueInicial, valueFinal, callbackFn = () => {}, validationFn = null, disabled, nameCampoInicial = "Data inicial", nameCampoFinal = "Data final", placeholderInicial = "Digite", placeholderFinal = "Digite", errorMessage = "Campo obrigatório") {
      this.id = id;
      this.name = name;
      this.label = label;
      this.required = required;
      this.valueInicial = valueInicial;
      this.valueFinal = valueFinal;
      this.callbackFn = callbackFn;
      this.validationFn = validationFn;
      this.disabled = disabled;
      this.nameCampoInicial = nameCampoInicial;
      this.nameCampoFinal = nameCampoFinal;
      this.placeholderInicial = placeholderInicial;
      this.placeholderFinal = placeholderFinal;
      this.errorMessage = errorMessage;
    }

  }